import { ThreeCardGameScreen } from '@/screens/three-card-poker/ThreeCardGameScreen'

export default function () {
  return <ThreeCardGameScreen />
}
